import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Navbar from './Components/Navbar/Navbar'; 
import Homepage from './Components/Pages/Homepage';
import Aboutus from './Components/Pages/Aboutus/Aboutus';
import Assignments from './Components/Pages/Assignments/Assignments';
import Gallery from './Components/Pages/Gallery/Gallery';
import NewsEvents from './Components/Pages/News/News';
import Mandetorydisclosure from './Components/Pages/Mandetorydisclosure/MD';
import Contactus from './Components/Pages/Contactus/Contactus';
import Admission from './Components/Pages/Admissionpage/admission';
import Teacherspanel from './Components/Pages/teacherspanel/teacherspanel';
import Adminpanel from './Components/Pages/Adminpanel/adminpanel';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/"                    element={<Homepage />} />
        <Route path="/about"               element={<Aboutus />} />
        <Route path="/assignments"         element={<Assignments />} />
        <Route path="/gallery"             element={<Gallery />} />
        <Route path="/news"                element={<NewsEvents />} />
        <Route path="/mandetorydisclosure" element={<Mandetorydisclosure />} />
        <Route path="/Contact"             element={<Contactus />} />
        <Route path="/admission"           element={<Admission />} />
        <Route path="/teacherspanel"           element={<Teacherspanel />} />
        <Route path="/Adminpanel"           element={<Adminpanel />} />
      </Routes>
    </Router>
  );
}

export default App;